let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1JlbJ")).then(() => parcelRequire('lk6xE'));